let cleanUpCommunityTabs

document.addEventListener('turbo:before-cache', () => cleanUpCommunityTabs?.())

document.addEventListener('turbo:load', () => {
    cleanUpCommunityTabs?.()
    const communityFeedItems = document.getElementById('community-feed-items')
    if (!communityFeedItems || document.documentElement.hasAttribute('data-turbo-preview')) return

    const recommendedButton = communityFeedItems.querySelector("button[data-option='recommended']")
    const followingButton = communityFeedItems.querySelector("button[data-option='following']")
    const indicator = communityFeedItems.querySelector('.indicator')
    const feedItemContainer = communityFeedItems.querySelector('.feed-item-container')
    const feedItemsRecommended = document.getElementById('feed_items_recommended')
    const feedItemsFollowing = document.getElementById('feed_items_following')
    const timers = new Set()

    function later(callback, delay) {
        const timer = setTimeout(() => {
            timers.delete(timer)
            callback()
        }, delay)
        timers.add(timer)
    }

    function updateSrcIfNeeded(option) {
        const frame = option === 'recommended' ? feedItemsRecommended : feedItemsFollowing
        const path = option === 'recommended' ? communityFeedItems.dataset.recommendedPath : communityFeedItems.dataset.followingPath
        // Loaded frames in Turbo's restoration cache already contain their original selection.
        if (!frame.getAttribute('src') && !frame.hasAttribute('complete')) frame.setAttribute('src', path)
    }

    function saveScrollPosition() {
        const activeTab = communityFeedItems.dataset.activeTab || 'recommended'
        communityFeedItems.dataset[`scrollY_${activeTab}`] = window.scrollY
    }

    function restoreScrollPosition(option = communityFeedItems.dataset.activeTab) {
        const savedPosition = parseInt(communityFeedItems.dataset[`scrollY_${option}`] || '0', 10)
        window.scrollTo(0, savedPosition)
    }

    function toggleClasses(option) {
        const isRecommended = option === 'recommended'
        recommendedButton.classList.toggle('text-warm-gray-900', isRecommended)
        recommendedButton.classList.toggle('text-warm-gray-600', !isRecommended)
        followingButton.classList.toggle('text-warm-gray-900', !isRecommended)
        followingButton.classList.toggle('text-warm-gray-600', isRecommended)
        indicator.classList.toggle('translate-x-[calc(100%+0.25rem)]', !isRecommended)
        indicator.classList.toggle('translate-x-0', isRecommended)
        feedItemContainer.classList.toggle('-translate-x-full', !isRecommended)
        feedItemContainer.classList.toggle('translate-x-0', isRecommended)
    }

    function setActiveTab(option, savePosition = true) {
        if (savePosition) saveScrollPosition()
        communityFeedItems.dataset.activeTab = option
        toggleClasses(option)
        updateSrcIfNeeded(option)
        localStorage.setItem('communityFeedTab', option)
        communityFeedItems.dispatchEvent(new CustomEvent('community:tab-change', { bubbles: true }))
        later(() => restoreScrollPosition(option), 50)
    }

    const showRecommended = () => setActiveTab('recommended')
    const showFollowing = () => setActiveTab('following')
    const resetFeedScroll = () => {
        communityFeedItems.dataset.scrollY_recommended = '0'
        window.scrollTo(0, 0)
    }
    const restoreAfterFrameLoad = (event) => {
        const activeFrame = communityFeedItems.dataset.activeTab === 'recommended' ? feedItemsRecommended : feedItemsFollowing
        if (event.target === activeFrame) later(() => restoreScrollPosition(), 100)
    }

    recommendedButton.addEventListener('click', showRecommended)
    followingButton.addEventListener('click', showFollowing)
    window.addEventListener('scroll', saveScrollPosition, { passive: true })
    document.addEventListener('turbo:before-visit', saveScrollPosition)
    document.addEventListener('turbo:frame-load', restoreAfterFrameLoad)
    communityFeedItems.addEventListener('community:feed-refresh', resetFeedScroll)

    cleanUpCommunityTabs = () => {
        saveScrollPosition()
        recommendedButton.removeEventListener('click', showRecommended)
        followingButton.removeEventListener('click', showFollowing)
        window.removeEventListener('scroll', saveScrollPosition)
        document.removeEventListener('turbo:before-visit', saveScrollPosition)
        document.removeEventListener('turbo:frame-load', restoreAfterFrameLoad)
        communityFeedItems.removeEventListener('community:feed-refresh', resetFeedScroll)
        timers.forEach(clearTimeout)
        cleanUpCommunityTabs = undefined
    }

    const savedTab = communityFeedItems.dataset.activeTab || localStorage.getItem('communityFeedTab')
    indicator.style.transition = 'none'
    feedItemContainer.style.transition = 'none'
    setActiveTab(savedTab === 'following' ? 'following' : 'recommended', false)
    indicator.offsetHeight
    indicator.style.transition = ''
    feedItemContainer.style.transition = ''
})
